export default function ImageBox({ image, alt }) {
    return (
        <div className="image-box">
            <img src={image} alt={alt}/>
        </div>
    );
}